import { Box, ButtonBase, IconButton, Paper, alpha } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";

export const SwitchDimensionButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  color: "white",
  padding: "8px 12px",
  fontSize: "12px",
  fontWeight: "bold",
  minWidth: "auto",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    borderColor: "rgba(255, 255, 255, 0.2)",
  },
}));

export const VideoUiToggleButton = styled(IconButton)<{ showButton?: boolean }>(({ theme, showButton = false }) => ({
  backgroundColor: showButton ? alpha(theme.palette.dsPrimary.v400, 0.5) : alpha(theme.palette.dsBase.v100, 0.5),
  color: "white",
  padding: "8px 12px",
  fontSize: "12px",
  fontWeight: "bold",
  minWidth: "auto",
  border: showButton ? "1px solid rgba(33, 150, 243, 0.2)" : "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: showButton ? "rgba(33, 150, 243, 0.9)" : "rgba(0, 0, 0, 0.8)",
    borderColor: showButton ? "rgba(33, 150, 243, 1)" : "rgba(255, 255, 255, 0.5)",
  },
}));

export const DecisionFilterMenuAnchor = styled(Box)({
  position: "relative",
});

export const DecisionFilterButton = styled(ButtonBase)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.25),
  minWidth: theme.spacing(20),
  padding: theme.spacing(1.25, 2),
  borderRadius: theme.spacing(20),
  color: theme.palette.common.white,
  backgroundColor: `${theme.palette.common.black}99`,
  backdropFilter: `blur(${theme.spacing(1)})`,
  transition: "background-color 0.3s ease, transform 0.2s ease",
  "&:hover": {
    backgroundColor: `${theme.palette.common.black}cc`,
    transform: "scale(1.03)",
  },
}));

export const DecisionFilterChevron = styled(motion.div)({
  display: "flex",
  alignItems: "center",
});

export const DecisionFilterDropdownMotion = styled(motion.div)({
  position: "absolute",
  top: "calc(100% + 8px)",
  right: 0,
  transformOrigin: "top right",
});

export const DecisionFilterDropdownCard = styled(Paper)(({ theme }) => ({
  minWidth: theme.spacing(34),
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(3),
  backgroundColor: `${theme.palette.common.black}99`,
  backdropFilter: `blur(${theme.spacing(1)})`,
}));

export const DecisionFilterOptionButton = styled(motion.button, {
  shouldForwardProp: prop => prop !== "isActive" && prop !== "isDisabled",
})<{ isActive: boolean; isDisabled: boolean }>(({ theme, isActive, isDisabled }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.spacing(2),
  padding: theme.spacing(1.4, 1.75),
  borderRadius: theme.spacing(1.5),
  color: theme.palette.common.white,
  backgroundColor: isActive ? theme.palette.dsPrimary.v300 : "transparent",
  opacity: isDisabled ? 0.45 : 1,
  border: 0,
  cursor: isDisabled ? "not-allowed" : "pointer",
  transition: "background-color 0.2s ease, color 0.2s ease",
  "&:hover": {
    backgroundColor: isActive ? theme.palette.dsPrimary.v300 : `${theme.palette.common.white}1f`,
  },
}));
